export interface SocketStateInterface {
  isConnected: boolean;
  message: string;
  reconnectError: boolean;
}

export default function (): SocketStateInterface {
  return {
    isConnected: false,
    message: '',
    reconnectError: false,
  };
}
